import ProfilePage from './Profile.component';

const ProfileContainer = function (): JSX.Element {
  return <ProfilePage />;
};

export default ProfileContainer;
